<template>
    <div>
        <div class="container">
            <h1>Overzicht <i class="fas fa-database align-right color-gray"> SQL</i></h1>
        </div>
        <div class="container" id="uislag">
            <h2>Klik op een vakje om de vraag, het antwoord en het aantal pogingen te zien.</h2>
            <div v-for="item in orderedUsers">
                <score-bar-component v-bind:items="item" v-if="item.ready != true"/>
            </div>
        </div>
    </div>
</template>

<script>
    import ScoreBarComponent from "./ScoreBarComponent";
    import axios from 'axios'
    import VueAxios from 'vue-axios'
    Vue.use(VueAxios, axios)
    axios
        .interceptors
        .request
        .use(function (config) {
            if (localStorage.getItem('user-token')) {
                config.headers['Authorization'] = 'Bearer '+localStorage.getItem('user-token');
            }
            return config;
        }, function (error) {
            return Promise.reject(error);
        });
    export default {
        name: "AllStudentsComponent",
        components: {ScoreBarComponent},
        data() {
            return {
                items : null
            }
        },
        created() {

            axios.get('/api/dashboard').then(resp => {
                this.items = resp.data;
                console.log(resp.data);
            });
        },
        computed: {
            orderedUsers: function () {
                return _.orderBy(this.items, 'name')
            }
        }
    }
</script>

<style scoped>
    #uislag {
        text-align: left;
    }

</style>
